import type { FeedbackSubmission } from '@studio/contract';
import { useMutation } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `POST /api/feedback` — submits a thumbs-up/thumbs-down quality signal for a
 * completed generation. Best-effort: the backend degrades silently on Firestore
 * failures, so this hook only surfaces network-level errors.
 *
 * Spec: docs/features/feedback.md (Phase 2)
 */
export function useSubmitFeedback() {
  const client = useStudioClient();
  return useMutation<{ ok: true }, Error, FeedbackSubmission>({
    mutationFn: async (body) => {
      const res = await client.api.feedback.$post({ json: body });
      if (!res.ok) throw await parseApiError(res);
      return res.json() as Promise<{ ok: true }>;
    },
  });
}
